import { ArrowCircleRightOutlined } from '@mui/icons-material';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';
import { AdData } from '../../types';
import { DisplayMarkup } from '../display-markup';
import { VideoFrame } from '../video-frame';

const useStyles = makeStyles((theme) => ({
  carouselContent: {
    position: 'relative',
    fontSize: 24,
    minHeight: 150,
    marginLeft: '260px',
    padding: '1.5rem',
    paddingRight: '3rem',
    lineHeight: 1.2,
    flex: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      fontSize: '1rem',
      paddingRight: '1.5rem',
      justifyContent: 'center',
      height: 220,
      flexDirection: 'column',
      textAlign: 'center',
      fontWeight: 400,
    },
  },
  carouselButton: {
    letterSpacing: '.5px',
    borderRadius: 50,
    textTransform: 'none',
    fontSize: 16,
    maxWidth: 300,
  },
  carouselImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    '& img': {
      height: '100%',
      width: 'auto',
      objectFit: 'contain',
      overflow: 'hidden',
    },
  },
  description: {
    [theme.breakpoints.down('lg')]: {
      fontSize: 18,
    },
  },
}));

export function BannerItem(props: { data: AdData }) {
  // Props
  const { data } = props;
  // Hooks
  const classes = useStyles();

  return (
    <Stack
      key={data.AdId}
      spacing={{ xs: 1, sm: 2 }}
      direction={{ xs: 'column', md: 'row' }}
      alignItems="center"
      justifyContent="space-between"
      sx={{ height: { md: 185 } }}
    >
      <Box
        aria-label={data.Name}
        className={classes.carouselImage}
        sx={{
          maxWidth: 260,
          width: '100%',
          height: 185,
        }}
      >
        {data.ImageURL ? (
          <img
            src={data.ImageURL}
            alt={data.Name}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              borderRadius: 10,
              overflow: 'hidden',
            }}
          />
        ) : null}
      </Box>

      <Box
        sx={{
          pb: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        {data.EmbedURL ? (
          <Box
            sx={{
              width: { xs: '60vw', sm: '40vw', md: '25vw', lg: '15vw' },
              maxWidth: 1080,
              overflow: 'hidden',
              borderRadius: 5,
            }}
          >
            <VideoFrame src={data.EmbedURL} title="banner video" />
          </Box>
        ) : null}

        {data.Description ? (
          <Box
            sx={{
              px: 2,
              pt: data.EmbedURL ? 1 : 2,
              pb: 0,
              textAlign: 'center',
              fontSize: data.EmbedURL ? 20 : 24,
              color: '#fff',
            }}
          >
            <DisplayMarkup
              markup={data.Description}
              className={classes.description}
            />
          </Box>
        ) : null}
      </Box>
      <Box sx={{ minWidth: 260, textAlign: 'center', pb: { xs: 1, md: 0 } }}>
        {data.ActionLink ? (
          <Button
            variant="contained"
            color="primary"
            size="small"
            component="a"
            target={
              !data.ActionLink.includes('https:') ||
              data.ActionLink.includes(window.location.host)
                ? '_self'
                : '_blank'
            }
            rel="noopener noreferrer"
            className={classes.carouselButton}
            href={data.ActionLink}
            endIcon={
              <ArrowCircleRightOutlined
                sx={{
                  marginLeft: 0.3,
                  transform: 'scale(1.3)',
                }}
              />
            }
          >
            {data.ActionText || 'Check It Out!'}
          </Button>
        ) : null}
      </Box>
    </Stack>
  );
}
